//
//  SDKUnit.ts
//  Supernova SDK
//
//  Created by Jiri Trecak.
//
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Token type enum
// TODO: Add exchaustive checks in switch
export var Unit;
(function (Unit) {
    Unit["pixels"] = "Pixels";
    Unit["percent"] = "Percent";
    Unit["rem"] = "Rem";
    Unit["ms"] = "Ms";
    Unit["raw"] = "Raw";
})(Unit || (Unit = {}));
export const SIZE_UNITS = [Unit.pixels, Unit.percent, Unit.rem];
export const LINE_HEIGHT_UNITS = [
    Unit.pixels,
    Unit.percent,
    Unit.rem,
    Unit.raw,
];
export const RAW_UNITS = [Unit.raw];
export const PX_UNITS = [Unit.pixels];
export const MS_UNITS = [Unit.ms];
